import _ from "lodash";
import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import { AthleteLinks } from "../../../parts/athlete-links";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import NotesEditor from "../../../parts/inputs/notes-editor";
import ConfirmationModal from "../../../parts/modals/ConfirmationModal";
import SvgIcon from "../../../parts/SvgIcon";
import TeamCard from "../../../parts/TeamCard";
import { RillContext } from "../../../rill/RillReact/share/base";
import getAvatarUrl from "../../../utils/get-avatar-url";
import { isTestAthlete } from "../../../utils/user-helpers";
import DemoAthleteInstructionsCard from "../../coaching-portal/athletes/components/DemoAthleteInstructionsCard";
import ChooseCoach from "../../dashboard/settings/manage-coaches/ChooseCoach";
import { getUsersAssignableAsCoach } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import AthleteProfileMenu from "./components/AthleteProfileMenu";
import DeletedTemplatePrompt from "./components/DeletedTemplatePrompt";
import ProfileTabs from "./components/ProfileTabs";
import { ProfileTabsMobile } from "./components/ProfileTabsMobile";
import { ViewContractButton } from "./components/ViewContractButton";

class Profile extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      athleteId: props.athlete._id,
      goals: [],
      limitations: [],
      equipment: [],
      notes: "",
      showCoachModal: false,
      selectedOrganizationCoach: this.context.locals.activeUser,
      coachOfAthlete: null,
      offsetHeight: null,
      openedConfiirmationModal: false,
      unconfirmedSelectedCoach: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.sendRequest = this.sendRequest.bind(this);
    this.selectOrganizationCoach = this.selectOrganizationCoach.bind(this);
    this.confirmSelectCoach = this.confirmSelectCoach.bind(this);
    this.cancelSelectCoach = this.cancelSelectCoach.bind(this);
  }

  componentDidMount() {
    const { goals, equipment, limitations, notes, coach } = this.props.athlete;
    const verified = {
      goals: typeof goals === "object" ? goals : [],
      equipment: typeof equipment === "object" ? equipment : [],
      limitations: typeof limitations === "object" ? limitations : [],
      notes: typeof notes === "string" ? notes : "",
      coach: coach || null,
    };
    this.setState({
      goals: verified.goals,
      equipment: verified.equipment,
      limitations: verified.limitations,
      notes: verified.notes,
      coachOfAthlete: verified.coach,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.athlete.notes !== this.state.notes ||
      nextProps.athlete.goals !== this.state.goals ||
      nextProps.athlete.equipment !== this.state.equipment ||
      nextProps.athlete.limitations !== this.state.limitations ||
      nextProps.athlete._id !== this.state.athleteId
    ) {
      const { goals, equipment, limitations, notes, coach } = nextProps.athlete;
      const verified = {
        goals: typeof goals === "object" ? goals : [],
        equipment: typeof equipment === "object" ? equipment : [],
        limitations: typeof limitations === "object" ? limitations : [],
        notes: typeof notes === "string" ? notes : "",
        coach: coach || null,
      };
      this.setState({
        athleteId: nextProps.athlete._id,
        goals: verified.goals,
        equipment: verified.equipment,
        limitations: verified.limitations,
        notes: verified.notes,
        coachOfAthlete: verified.coach,
      });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  sendRequest(values) {
    const coachOrganizationInformation =
      this.context.locals.coachOrganizationInformation || undefined;
    let body = {
      goals: this.state.goals,
      limitations: this.state.limitations,
      equipment: this.state.equipment,
      notes: values.notes ? values.notes : this.state.notes,
    };

    if (coachOrganizationInformation) {
      body = { ...body, coachOrganizationInformation };
    }

    submit(`/actions/user/update-athlete-profile/${this.state.athleteId}`, {
      method: "POST",
      body,
    });
  }

  selectOrganizationCoach = (_e, coach) => {
    if (
      coach &&
      coach._id.toString() !== this.state.coachOfAthlete?._id.toString()
    ) {
      this.setState((_prevState) => ({
        unconfirmedSelectedCoach: coach,
        openedConfiirmationModal: true,
      }));
    }
  };
  confirmSelectCoach = () => {
    submit(`/actions/organizations/re-assign-coach`, {
      method: "POST",
      body: {
        coachToId: this.state.unconfirmedSelectedCoach._id, // coach to be assigned to
        coachFromId: this.state.coachOfAthlete?._id, // coach to be removed from
        athleteId: this.state.athleteId,
      },
    });
    this.setState((prevState) => ({
      selectedOrganizationCoach: prevState.unconfirmedSelectedCoach,
      unconfirmedSelectedCoach: null,
      openedConfiirmationModal: false,
    }));
  };
  cancelSelectCoach = () => {
    this.setState((_prevState) => ({
      openedConfiirmationModal: false,
      unconfirmedSelectedCoach: null,
    }));
  };
  render() {
    const { athlete, organizationCoachId, t } = this.props;
    const { coachOfAthlete, openedConfiirmationModal } = this.state;
    const athleteStatus = !_.get(athlete, "status.inactive", false);
    const { locals } = this.context;
    const {
      activeUser,
      pathname,
      query,
      usersOrganization = {
        organizationActiveUsers: [],
      },
      organizationRoleName,
    } = locals;

    const { organizationActiveUsers = [] } = usersOrganization;
    const organizationCoach = query.organizationCoach || undefined;
    const section = query.section;
    const clientConfigurationPending = !locals.clientConfiguration?._id;

    //organizations validations
    const isAthleteWithOrganizationId = !!athlete?.coach?.organizationId;
    const isOrganizationUser =
      !!activeUser.organizationId && !!activeUser.organizationRoleId;
    const isAdminOrOwner =
      organizationRoleName === "Owner" || organizationRoleName === "Admin";
    const isTeamCoach = organizationRoleName === "Team Coach";
    const isNutritionistOrCoach =
      organizationRoleName === "Nutritionist" ||
      organizationRoleName === "Coach";
    const isInActiveUserAthletes =
      athlete && activeUser.athletes && activeUser.athletes.length > 0
        ? activeUser.athletes.some((a) => a._id === athlete._id)
        : false;

    const allowedToChangeOrganizationCoach =
      !isTestAthlete(athlete.email, activeUser.email) &&
      isAthleteWithOrganizationId &&
      isOrganizationUser &&
      (isAdminOrOwner ||
        isTeamCoach ||
        (isNutritionistOrCoach && isInActiveUserAthletes));

    const ActionTrainingComponent = ({ classNames }) => {
      return (
        !athlete.isGymMember &&
        organizationRoleName !== "Nutritionist" && (
          <>
            {!athleteStatus && (
              <a
                role="button"
                data-button-type="outline"
                className={`Profile button remove-button start-button ${classNames}`}
                href={
                  organizationCoach
                    ? `/athlete-portal/profile/start-training/?athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                    : `/athlete-portal/profile/start-training/?athlete=${athlete._id}`
                }
              >
                <span>{t("profile.startTraining")}</span>
              </a>
            )}

            <a
              className={`${classNames}`}
              role="button"
              data-button-type="secondary"
              data-action="cancel"
              href={`/actions/refresh?modal[type]=${
                athleteStatus ? "stop-training" : "remove-athlete"
              }`}
            >
              {athleteStatus ? t("profile.stopTraining") : t("common:remove")}
            </a>
          </>
        )
      );
    };

    return (
      <main className="profile">
        <div
          className={
            section === "dashboard"
              ? "athlete-section-header only-show-mobile"
              : "athlete-section-header only-show-mobile with-border"
          }
        >
          <AthleteLinks
            athlete={athlete}
            pathName={pathname}
            classNames={"only-show-mobile"}
            query={query}
          />
          <div className="athlete-select dropdown-athlete">
            <div
              className="avatar"
              style={{
                backgroundImage: `url(${getAvatarUrl(athlete)})`,
              }}
            />
            <AthleteSelect
              locals={locals}
              {...(section === "periodization" && { athleteSwitch: true })}
            />
          </div>
          <ProfileTabsMobile
            section={section}
            athlete={athlete}
            query={query}
            activeUser={activeUser}
            classNames={"only-show-mobile"}
            clientConfigurationPending={clientConfigurationPending}
          />
        </div>
        <aside>
          <AthleteProfileMenu
            athlete={athlete}
            locals={locals}
            organizationCoachId={organizationCoachId}
          />
          <article
            className={`view-contract-article ${
              section === "dashboard" ? "" : "force-mobile-hidden"
            }`}
            data-view-contract
          >
            <ViewContractButton athlete={athlete} api={this.props.api} />
          </article>
          {locals.athleteTeam && locals.athleteTeam.length > 0 ? (
            <TeamCard team={locals.athleteTeam[0]} />
          ) : locals.athleteFlexibleProgram &&
            locals.athleteFlexibleProgram.length > 0 ? null : (
            <button
              type="button"
              data-button-type="outline"
              className="invite-to-team-button"
              onClick={() => {
                submit("/actions/refresh", {
                  method: "GET",
                  body: {
                    "modal[type]": "invite-to-team",
                  },
                });
              }}
            >
              <SvgIcon
                src="/img/new-icons/person-add.svg"
                noFilterOnLight={true}
              />
              <span>{t("profile.inviteToTeam")}</span>
            </button>
          )}
          {/* init only for screens > 640 */}
          <NotesEditor
            classNames={
              athleteStatus
                ? "mobile-hidden"
                : "mobile-hidden notes-editor-inactive-athlete"
            }
            value={this.state.notes}
            handleChange={this.handleChange}
            onSave={() =>
              this.sendRequest({
                notes: this.state.notes,
              })
            }
          />
          {/* end only for screens > 640 */}

          {/* organization changing coach section */}
          {allowedToChangeOrganizationCoach && athleteStatus && (
            <>
              <label
                className={section === "dashboard" ? "" : "force-mobile-hidden"}
              >
                {t("profile.assignedCoach")}
              </label>
              <ChooseCoach
                activeUser={activeUser}
                organizationActiveUsers={getUsersAssignableAsCoach(
                  organizationActiveUsers
                )}
                onSelectCoach={this.selectOrganizationCoach}
                selectedCoach={
                  coachOfAthlete &&
                  organizationActiveUsers.find(
                    (obj) =>
                      obj._id.toString() === coachOfAthlete._id?.toString()
                  )
                }
                classNames={
                  section === "dashboard" ? "" : "force-mobile-hidden"
                }
              />
            </>
          )}

          {/* init only for screens > 640 */}
          <ActionTrainingComponent classNames="mobile-hidden" />
          {/* end only for screens > 640 */}
        </aside>
        <section>
          <ProfileTabs
            section={section}
            athlete={athlete}
            query={query}
            activeUser={activeUser}
            clientConfigurationPending={clientConfigurationPending}
          />
          <DemoAthleteInstructionsCard
            activeUser={activeUser}
            visibleForAthleteId={athlete._id}
          />
          {this.props.children}

          {/* init only show notes and actions for mobile */}
          <NotesEditor
            classNames={
              section === "dashboard"
                ? "only-show-mobile"
                : "force-mobile-hidden only-show-mobile"
            }
            value={this.state.notes}
            handleChange={this.handleChange}
            onSave={() =>
              this.sendRequest({
                notes: this.state.notes,
              })
            }
          />
          <ActionTrainingComponent
            classNames={
              section === "dashboard"
                ? "only-show-mobile"
                : "force-mobile-hidden only-show-mobile"
            }
          />

          {/* end init only show notes and actions for mobile */}

          {allowedToChangeOrganizationCoach && athleteStatus && (
            <ConfirmationModal
              isOpen={openedConfiirmationModal}
              title={t("profile.reAssignCoach")}
              contentText={t("profile.reAssignCoachConfirm")}
              cancelButtonText={t("common:cancel")}
              confirmButtonText={t("profile.assign")}
              confirmButtonAction={this.confirmSelectCoach}
              cancelButtonAction={this.cancelSelectCoach}
            />
          )}
          {locals.clientConfiguration?.templateDeletedAt && (
            <DeletedTemplatePrompt />
          )}
        </section>
      </main>
    );
  }
}

Profile.contextType = RillContext;

export default withTranslation(["athlete-portal", "common"])(Profile);
